import { FunctionComponent } from 'react';
import { DuskEntrance } from './DuskEntrance';
import { FlyingBats } from './FlyingBats';
import { RoostingBat } from './RoostingBat';
import { SpiderWeb } from './SpiderWeb';

import classes from './Halloween.module.scss';

export const Halloween: FunctionComponent = () => {
  return (
    <div aria-hidden={'true'} className={classes['halloween']}>
      <FlyingBats />
      <RoostingBat />
      <DuskEntrance />
      <SpiderWeb />
    </div>
  );
};
